import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PatientDetail, Patient } from '@models/appointments/patient.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpBaseService } from './http-base.service';
import { AuthService } from './auth.sevice';
import { AuthTokenHelper } from '../helpers/auth-token-helper';
import { DatePipe } from '@angular/common';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';

@Injectable()
export class PatientService {
  private readonly API_URL = 'assets/data/patient.json';
  dataChange: BehaviorSubject<PatientDetail[]> = new BehaviorSubject<PatientDetail[]>([]);
  // Temporarily stores data from dialogs
  dialogData: any;
  constructor(
    private httpClient: HttpClient,
    private httpBaseService: HttpBaseService,
    public datepipe: DatePipe,
    private authService?: AuthService,
    private authHelper?: AuthTokenHelper
  ) { }

  get data(): PatientDetail[] {
    return this.dataChange.value;
  }
  
  getDialogData() {
    return this.dialogData;
  }

  /** CRUD METHODS */
  getAllHolidays(): void {
    this.httpClient.get<PatientDetail[]>(this.API_URL).subscribe(
      data => {
        this.dataChange.next(data);
      },
      (error: HttpErrorResponse) => {
        console.log(error.name + ' ' + error.message);
      }
    );
  }

  getSuffixMaster(URL): Observable<any> {
    try {    
      const body = {};
      return this.httpBaseService.get(URL, body);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }
  getPatientStatusMaster(URL): Observable<any> {
    try {
      const body = {};
      return this.httpBaseService.get(URL, body);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }
  getPatientDetailMaster(URL): Observable<any> {
    try {
      const body = {};
      return this.httpBaseService.get(URL, body);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  getAllPatientDetail(URL): Observable<any> {
    try {
      const body = {};
      return this.httpBaseService.post(URL, body);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  addPatient(url:string, patient: Patient) {
    try {
      let apiURL = '';
      this.httpBaseService.getAPIURL().subscribe(url => {
        apiURL = `${url.API_URL}`       
      });
      patient.Id = 0;
      patient.DOB = this.datepipe.transform(new Date(patient.DOB), BeyondEMRConstants.DateDBFormat);
      return this.httpBaseService.post(apiURL + url, patient);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  addPatientWithFile(url: string, patient: Patient, fileAttachments: any | null) {
    try {
      let formData = new FormData();     

      if (patient?.DOB != null) {
        patient.EmergencyContact.DOB = this.datepipe.transform(new Date(patient.DOB), BeyondEMRConstants.DateDBFormat);
      }
        
      formData.append('item', JSON.stringify(patient));
      if (fileAttachments) {
        fileAttachments.forEach(function (value, key) {
          formData.append(value.name, value);
        });
      }
      return this.httpBaseService.postWithFile(url, formData);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  publicPatientWithFile(url: string, dbName: string, patient: Patient, fileAttachments: any | null) {
    try {     
      let data = new Patient();      
      let formData = new FormData();
      formData.append('dbName', dbName);
      formData.append('item', JSON.stringify(patient));
      if (fileAttachments) {
        fileAttachments.forEach(function (value, key) {
          formData.append(value.name, value);
        });
      }
      return this.httpBaseService.postWithFile(url, formData, false);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  // sendPatientIntake(url: string, intakeUrl: string, patientId: number) {
  //   try {
  //     const param = { intakeUrl: intakeUrl, patientId: patientId};
  //     return this.httpBaseService.get(url, param);     
  //   } catch (error) {
  //     console.log(error.name + ' ' + error.message);
  //     return new Observable<any>();
  //   }
  // }

  SendDemographicUpdateEmail(url: string) {
    try {
      return this.httpBaseService.get(url);     
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  GetFiles(url: string, dbName: string) {
    try {
      var hasHeader = dbName ? false : true;
      return this.httpBaseService.postBlob(url, null, hasHeader);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  updatePatientDetail(patient: PatientDetail): void {
    this.dialogData = patient;
  }

  deletePatientDetail(id: number): void {
    console.log(id);
  }
}
